import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n\t* {\n\t\tcursor: ns-resize;\n\t}\n"]);

  _templateObject19 = function () {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n\t* {\n\t\tcursor: ew-resize;\n\t}\n"]);

  _templateObject18 = function () {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject17 = function () {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject16 = function () {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tborder: 1px solid transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: block;\n\toutline: none;\n\tpadding: 3px;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:focus {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n\n\t&[disabled] {\n\t\tpointer-events: none;\n\t}\n"]);

  _templateObject15 = function () {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmargin: 0 -2px 0 0 !important;\n\topacity: 1;\n"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmargin-top: -1px;\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmargin-bottom: -1px;\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: transparent;\n\tborder-radius: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tpadding: 0 2px;\n\n\t&:hover:active {\n\t\tbackground-color: ", ";\n\t}\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 24px;\n\tmargin: 0 -6px 0 0 !important;\n\topacity: 0.6;\n\tuser-select: none;\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tdisplay: flex;\n\theight: 100%;\n\tjustify-content: center;\n\tmargin: 0 !important;\n\tmin-height: 0;\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tresize: vertical;\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: calc(", " - 2px);\n\tpadding-bottom: calc((", " - 2px - 18px) / 2);\n\tpadding-top: calc((", " - 2px - 18px) / 2);\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: calc(", " - 2px);\n\tpadding-bottom: calc((", " - 2px - 18px) / 2);\n\tpadding-top: calc((", " - 2px - 18px) / 2);\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tappearance: none;\n\tbackground: transparent;\n\tborder: none;\n\tborder-radius: ", ";\n\tbox-shadow: none;\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\tdisplay: block;\n\tflex: 1;\n\tline-height: 18px;\n\tmin-height: calc(", " - 2px);\n\toutline: none;\n\tpadding: 0;\n\tpadding-bottom: calc((", " - 2px - 18px) / 2);\n\tpadding-top: calc((", " - 2px - 18px) / 2);\n\tresize: none;\n\ttext-align: left;\n\twidth: 100%;\n\n\t", ";\n\n\t&::-webkit-outer-spin-button,\n\t&::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n\n\t/* Firefox */\n\t&[type='number'] {\n\t\t-moz-appearance: textfield;\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\n\t@media (min-width: 36em) {\n\t\tfont-size: ", ";\n\t}\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: 8px;\n\tpadding-right: 8px;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: 0;\n\tpadding-right: 0;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export { scrollableScrollbar } from '../Scrollable/Scrollable.styles';
export var focus = css(_templateObject(), ui.color.admin);
export var multiline = css(_templateObject2());
export var inputMultiline = css(_templateObject3());
export var inputFontSize = css(_templateObject4(), ui.get('fontSizeInputMobile'), ui.get('fontSize'));
export var Input = css(_templateObject5(), ui.get('controlBorderRadius'), ui.color.text, ui.get('controlHeight'), ui.get('controlHeight'), ui.get('controlHeight'), inputFontSize);
export var large = css(_templateObject6(), ui.get('controlHeightLarge'), ui.get('controlHeightLarge'), ui.get('controlHeightLarge'));
export var small = css(_templateObject7(), ui.get('controlHeightSmall'), ui.get('controlHeightSmall'), ui.get('controlHeightSmall'));
export var resizable = css(_templateObject8());
export var SpinnerWrapper = css(_templateObject9());
export var Spinner = css(_templateObject10());
export var SpinnerArrow = css(_templateObject11(), ui.get('controlBorderRadius'), ui.get('colorText'), ui.get('controlBackgroundColorHover'));
export var SpinnerArrowUp = css(_templateObject12(), SpinnerArrow);
export var SpinnerArrowDown = css(_templateObject13(), SpinnerArrow);
export var Steppers = css(_templateObject14(), Spinner);
export var StepperButton = css(_templateObject15(), SpinnerArrow, ui.get('controlInnerControltextColor'), ui.get('controlBackgroundColorHover'), ui.get('controlBackgroundColorHover'), ui.get('colorAdmin'));
export var SteppersUp = css(_templateObject16(), StepperButton);
export var SteppersDown = css(_templateObject17(), StepperButton);
export var globalDraggableX = css(_templateObject18());
export var globalDraggableY = css(_templateObject19());